import { render, staticRenderFns } from "./tenders.vue?vue&type=template&id=053c4872&scoped=true&"
import script from "./tenders.vue?vue&type=script&lang=js&"
export * from "./tenders.vue?vue&type=script&lang=js&"
import style0 from "./tenders.vue?vue&type=style&index=0&id=053c4872&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c4872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053c4872')) {
      api.createRecord('053c4872', component.options)
    } else {
      api.reload('053c4872', component.options)
    }
    module.hot.accept("./tenders.vue?vue&type=template&id=053c4872&scoped=true&", function () {
      api.rerender('053c4872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/tenders.vue"
export default component.exports